import { types } from './actions';

const initialState = {
  areManufacturerNotesFetching: false,
  manufacturerNotes: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FETCH_MANUFACTURER_NOTES_ERROR:
      return {
        ...state,
        areManufacturerNotesFetching: false,
      };
    case types.FETCH_MANUFACTURER_NOTES_SUCCESS:
      return {
        ...state,
        areManufacturerNotesFetching: false,
        manufacturerNotes: payload.manufacturerNotes,
      };

    case types.UPDATE_MANUFACTURER_NOTES_ERROR:
      return {
        ...state,
        areManufacturerNotesFetching: false,
      };
    case types.UPDATE_MANUFACTURER_NOTES_REQUEST:
      return {
        ...state,
        areManufacturerNotesFetching: true,
      };
    case types.UPDATE_MANUFACTURER_NOTES_SUCCESS:
      return {
        ...state,
        areManufacturerNotesFetching: false,
        manufacturerNotes: payload.manufacturerNotes,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.smartRfq.manufacturerNotes;

export const areManufacturerNotesFetching = (state) =>
  getScope(state).areManufacturerNotesFetching;

export const getManufacturerNotes = (state) =>
  getScope(state).manufacturerNotes;
